module.exports = __webpack_public_path__ + "img/overview.f4f163bf.svg";